export enum AvatarType {
    HUMAN = "HUMAN",
    ROBOT = "ROBOT"
}